import { useForm } from '@mantine/form';
import { Button, Group, TextInput, Loader, Stack, Modal } from '@mantine/core';
import type { PartnerAccountant } from '../../../models/partnerAccountant.ts';

export interface UpdatePartnerAccountantForm {
  name: string;
  email: string;
}

interface UpdatePartnerAccountantModalProps {
  opened: boolean;
  onClose: () => void;
  onConfirm: ({
    formValues,
  }: {
    formValues: UpdatePartnerAccountantForm;
  }) => void;
  row: PartnerAccountant;
  isPending: boolean;
}

export default function UpdatePartnerAccountantModal({
  opened,
  onClose,
  onConfirm,
  row,
  isPending,
}: UpdatePartnerAccountantModalProps) {
  const form = useForm<UpdatePartnerAccountantForm>({
    mode: 'uncontrolled',
    initialValues: {
      name: row.name,
      email: row.email,
    },
    validate: {
      name: (value) => (value ? null : ' '),
      email: (value) => (value ? null : ' '),
    },
  });

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title="編輯會計人員"
      centered
      styles={{ title: { fontWeight: 700, fontSize: 16 } }}
    >
      {isPending ? (
        <Loader />
      ) : (
        <Stack>
          <form
            onSubmit={form.onSubmit((values: UpdatePartnerAccountantForm) =>
              onConfirm({ formValues: values }),
            )}
          >
            <TextInput
              withAsterisk
              label="人員名稱"
              placeholder="請輸入人員名稱"
              key={form.key('name')}
              {...form.getInputProps('name')}
            />
            <TextInput
              mt="md"
              withAsterisk
              label="Email"
              placeholder="請輸入Email"
              key={form.key('email')}
              {...form.getInputProps('email')}
            />
            <Group justify="flex-end" mt="md">
              <Button
                type="button"
                onClick={onClose}
                variant="outline"
                fw={400}
              >
                取消
              </Button>
              <Button type="submit" fw={400} loading={isPending}>
                更新
              </Button>
            </Group>
          </form>
        </Stack>
      )}
    </Modal>
  );
}
